import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ResearchCard from "../../../components/ResearchCard";
import { ResearchCards } from "../../../constants/home_research_cards";
import { useNavigate } from "react-router-dom";
import PdfDialog from "../../../components/PdfDialog";

const ResearchSection = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [showPdfDialog, setShowPdfDialog] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");

  const onShowResearchPaper = ({
    title,
    pdf,
  }: {
    title: string;
    pdf: string;
  }) => {
    setShowPdfDialog(true);
    setPdfTitle(title);
    setPdfUrl(pdf);
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.secondaryBackground.main,
        paddingTop: {
          xs: "36px",
          md: "74px",
        },
        paddingBottom: {
          xs: "36px",
          md: "74px",
        },
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          paddingLeft: {
            xs: "24px",
            md: 0,
          },
          paddingRight: {
            xs: "24px",
            md: 0,
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: 400,
            marginBottom: "2px",
          }}
        >
          Latest Topics
        </Typography>

        <Typography
          sx={{
            fontSize: "20px",
            marginBottom: "24px",
          }}
        >
          These are some of the exciting research projects we have been working
          on.
        </Typography>

        <Button
          variant="text"
          onClick={() => {
            navigate("/research");
          }}
        >
          View All Research Projects
        </Button>
      </Box>

      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        sx={{
          marginTop: "36px",
          marginLeft: "50px",
          marginRight: "50px",
        }}
      >
        {ResearchCards.map((card, index) => (
          <Grid
            size={{ xs: 12, md: 4 }}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ResearchCard
              title={card.title}
              description={card.description}
              image={card.image}
              link={card.link}
              author={card.author}
              isPdf={card.isPdf}
              onPDFClick={() =>
                onShowResearchPaper({
                  title: card.title,
                  pdf: card.pdf!,
                })
              }
            />
          </Grid>
        ))}
      </Grid>

      <PdfDialog
        open={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
        title={pdfTitle}
        pdfUrl={pdfUrl}
      />
    </Box>
  );
};

export default ResearchSection;
